<template>
    <ClinicList/>
</template>

<script lang="ts" setup>
definePageMeta({
  validate: async (route) => {
    return typeof route.params.city === 'string' && /^[a-z-]+$/.test(route.params.city)
  }
});
</script>

<style lang="scss">
//tets
</style>